import { defineComponent, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from "vue";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Tooltip/TooltipTrigger.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TooltipTrigger",
  props: {
    reference: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({ "data-slot": "tooltip-trigger" }, props, { "as-child": "" }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipTrigger.js.map
